import React, { useState } from "react";
import UserResultPage from "./UserResultPage";

function AdminResultPage({ adminData }) {
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedAttempt, setSelectedAttempt] = useState(null);

  const handleUserClick = (user) => {
    setSelectedUser(user);
    setSelectedAttempt(null);
  };

  const handleAttemptClick = (attempt) => {
    setSelectedAttempt(attempt);
  };

  // ✅ Function to parse ISO 8601 duration (e.g., PT22S → 22s, PT1M30S → 1m 30s)
  const parseDuration = (isoDuration) => {
    if (!isoDuration) return "N/A";
    const match = isoDuration.match(/PT(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?/);
    if (!match) return isoDuration;

    const hours = match[1] ? `${match[1]}h ` : "";
    const minutes = match[2] ? `${match[2]}m ` : "";
    const seconds = match[3] ? `${match[3]}s` : "";

    return `${hours}${minutes}${seconds}`.trim();
  };

  return (
    <div className="admin-heading">
      {!selectedUser ? (
        // Step 1: Show all users with their **best attempt**
        <div className="admin-grid">
          {adminData?.length > 0 ? (
            adminData.map((user, index) => {
              // ✅ Find best attempt
              const bestAttempt = user.attempts?.reduce(
                (best, current) =>
                  !best || current.score > best.score ? current : best,
                null
              );

              // {
              //   console.log("Best Attempt for", user.username, bestAttempt);
              //   console.log(
              //     "User:",
              //     user.username,
              //     "Attempts:",
              //     user.attempts,
              //     "Length:",
              //     user.attempts?.length
              //   );
              // }
              return (
                <div
                  className="result-card"
                  key={index}
                  onClick={() => handleUserClick(user)}
                  style={{ cursor: "pointer" }}
                >
                  <p>
                    👤 <strong>User:</strong> {user.username}
                  </p>
                  {bestAttempt ? (
                    <>
                      <p>
                        🏁 <strong>Score:</strong> {bestAttempt.score}
                      </p>
                      <p>
                        ⏱️ <strong>Submitted At:</strong>{" "}
                        {new Date(bestAttempt.submittedAt).toLocaleString()}
                      </p>
                      <p>
                        ✅ <strong>Finish Time:</strong>{" "}
                        {parseDuration(bestAttempt.finishTime)}
                      </p>
                    </>
                  ) : (
                    <p>No attempts found.</p>
                  )}
                </div>
              );
            })
          ) : (
            <p>No user submissions found.</p>
          )}
        </div>
      ) : !selectedAttempt ? (
        // Step 2: Show all attempts of the selected user
        <div className="attempts-list">
          <div className="attempts-list-heading">
            <button className="back-btn" onClick={() => setSelectedUser(null)}>
              🔙 Back to Users
            </button>
            <h2>Attempts by {selectedUser.username}</h2>
          </div>
          {selectedUser.attempts?.length > 0 ? (
            selectedUser.attempts.map((attempt, idx) => (
              <div
                key={idx}
                className="attempt-card"
                onClick={() => handleAttemptClick(attempt)}
                style={{
                  cursor: "pointer",
                  border: "1px solid #ccc",
                  margin: "8px",
                  padding: "8px",
                }}
              >
                <p>
                  📝 <strong>Attempt {idx + 1}</strong>
                </p>
                <p>
                  🏁 Score: {attempt.score}/{attempt.maxScore}
                </p>
                <p>
                  ⏱️ Submitted: {new Date(attempt.submittedAt).toLocaleString()}
                </p>
                <p>✅ Finish Time: {parseDuration(attempt.finishTime)}</p>
              </div>
            ))
          ) : (
            <p>No attempts found.</p>
          )}
        </div>
      ) : (
        // Step 3: Show individual attempt details
        <div>
          <button
            className="back-attemp-btn"
            onClick={() => setSelectedAttempt(null)}
          >
            🔙 Back to Attempts
          </button>
          <UserResultPage userdata={selectedAttempt} />
        </div>
      )}
    </div>
  );
}

export default AdminResultPage;
